module.exports = __webpack_public_path__ + "img/0034.8907af7c.gif";